module.exports = __webpack_public_path__ + "static/thomson-local-app-preview-cfab42649027958c2179f8e05a85d903.jpg";